module.exports = __webpack_public_path__ + "static/media/9.d97e9392.jpg";